export default __webpack_public_path__ + "static/media/social-mail.00001abf.svg";